<div class="layout-header font-main">
    <header [menus]="menus"></header>
</div>
<div class="layout-content">
    <ng-content></ng-content>
</div>
<div class="layout-footer">
     <footer></footer>
</div>
